
//  export const IP =  'https://dongtai.huayiyun.net:8888/admin-api'
export const IP =  'https://demo-dongtai.huayiyun.net:8082/dongtai-admin-api'
// export const IP =  'http://192.168.2.78:8080'
                                   
const domain={
    getImageCode:IP+'/getImageCode',//获取图形验证码
    getImgCodeState:IP+'/getImgCodeState',//验证码是否验证标志

    login:IP+'/login',//登录
    logout:IP+'/logout',//退出登录
    modifyPassword:IP+'/modifyPassword',//修改密码

    listHospInfo:IP+'/hosp/list', //获取医院列表
    getHospDetail:IP+'/hosp/get',//查询医院详情
    addHosp:IP+'/hosp/add', //添加医院
    updateHosp:IP+'/hosp/update', //修改医院信息
    listHospRank:IP+'/base/listHospRank', //获取医院级别列表
    
    update:IP+'/hosp/balance/update',//修改医院账户信息
    getCharge:IP+'/hosp/charge/get',//查询医院账户信息
    saveCharge:IP+'/hosp/charge/update',//保存医院账户信息
    addHospAdmin:IP+'/admin/create', //添加医院管理员
    resetAdminPwd:IP+'/admin/resetPwd', //重置医院管理员密码
    getAdmin:IP+'/admin/get', //查看管理员信息

    listChildHosp:IP+'/child/list', //获取已配置下级医院列表
    notAssignedList:IP+'/child/listUnBind', //获取未配置医院列表
    listParentHosp:IP+'/child/listParent',
    addChildHosp:IP+'/child/add', //添加下级医院
    delChild:IP+'/child/disbale', //删除下级医院
    getChildCharge:IP+'/child/get',//查询下级医院 收费
    saveChildCharge:IP+'/child/update',//保存下级医院收费

    listRegion:IP+'/base/listRegion',//获取地址（五级联动）


    queryStaff:IP+'/admin/queryStaff',//查询员工列表
    openAccount:IP+'/admin/openAccount',//员工开户
    delStaff:IP+'/admin/delStaff',//员工 删除
    resetStaffPwd:IP+'/admin/updateStaffPassword',//重置员工密码

    judgeDocIsExist:IP+'/admin/judgeDocIsExist',//根据手机号查询用户信息
    listPayRecord:IP+'/hosp/balance/list',//获得交易记录


    //医生管理
    updateUserInfo:IP+'/admin/updateUserInfo',//医生启用与禁用
    queryUserFromHosp:IP+'/admin/queryUserFromHosp',//获得医生列表
    judgeDocIsExist:IP+'/admin/judgeDocIsExist',//根据手机号查询医生信息
    openUserAccount:IP+'/admin/openUserAccount',//医生开户
    queryRoleList:IP+'/admin/queryRoleList',

    //病例管理
    getCaseList:IP+'/case/list',
    exportCaseStatistics:IP+'/case/exportCaseStatistics',//数据导出
    getDiag:IP+'/case/getDiag',

    //数据统计
    countByEmergRate:IP+'/case/countByEmergRate',//急诊病例数
    countByGender:IP+'/case/countByGender',//性别病例数
    countByAge:IP+'/case/countByAge',//年龄病例数
    countBySatatus:IP+'/case/countBySatatus',//状态病例数
    countByDevice:IP+'/case/countByDevice',//设备病例数
    getReadAndWriteOSS:IP+'/oss/getReadAndWriteOSS',//获取oss账号

    listByRegion:IP+'/hosp/listByRegion',///根据地区获取医院
    //地区监控
    regionList:IP+'/regionData/list',
    regionAdd:IP+'/regionData/add',
    regionUpdate:IP+'/regionData/update',
    regionDelete:IP+'/regionData/delete',
    //日志列表
    // listLogUser:IP+'/logUser/list',
    listLogUser:IP+'/log/list',
}

export default domain



// WEBPACK FOOTER //
// ./src/service/getDate.js